import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { SheetsDisplayGridRowDataFragmentGql } from './SheetsDisplayGridRowFragmentGql';

export const DownstreamSheetsFilteredByFieldQueryGql: DocumentNode = gql`
query DownstreamSheetsFilteredByFieldQuery($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...SheetsDisplayGridRowDataFragment
        }
      }
    }
  }
}
${SheetsDisplayGridRowDataFragmentGql}
`;
